import { useSelector } from 'react-redux';
import { Text, Modal, Button, Navigation, Cell, Card, Divider } from '@vinted/web-ui';
import useTracking from 'hooks/useTracking';
import useTranslate from 'hooks/useTranslate';
import ScrollableArea from 'components/ScrollableArea';
import { formatCurrencyAmount } from 'libs/utils/formatString';
import { navigateToPage } from 'libs/utils/window';
import { clickEvent } from 'libs/common/event-tracker/events';
import { getLocale } from 'state/intl/selectors';
import { FEATURED_COLLECTION_URL } from 'constants/routes';
import { ClickableElement } from 'constants/tracking/clickable-elements';
import { Screen } from 'constants/tracking/screens';
import SeparatedList from 'components/SeparatedList';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

const MultipleCollectionsPlansModal = _ref => {
  let {
    isShown,
    plansPricing,
    onBack
  } = _ref;
  const {
    track
  } = useTracking();
  const translate = useTranslate('featured_collection.multiple.plans_modal');
  const locale = useSelector(getLocale);

  function handleCreateCollectionsClick() {
    track(clickEvent({
      screen: Screen.FeaturedCollection,
      target: ClickableElement.CreateCollection
    }));
    navigateToPage(FEATURED_COLLECTION_URL);
  }

  function renderNavigation() {
    return /*#__PURE__*/_jsx(Navigation, {
      left: /*#__PURE__*/_jsx(Button, {
        deprecatedIconName: "arrow-left",
        theme: "amplified",
        styling: Button.Styling.Flat,
        testId: "multiple-collections-plans-back-button",
        onClick: onBack
      }),
      body: /*#__PURE__*/_jsx(Text, {
        type: Text.Type.Title,
        width: Text.Width.Parent,
        alignment: Text.Alignment.Center,
        text: translate('title')
      })
    });
  }

  function renderContent() {
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(Cell, {
        children: /*#__PURE__*/_jsx(Text, {
          text: translate('body')
        })
      }), /*#__PURE__*/_jsx("div", {
        className: "u-ui-margin-horizontal-large u-ui-margin-bottom-large",
        children: /*#__PURE__*/_jsx(Card, {
          children: /*#__PURE__*/_jsx("div", {
            className: "u-overflow-hidden",
            children: /*#__PURE__*/_jsx(SeparatedList, {
              separator: /*#__PURE__*/_jsx(Divider, {}),
              children: plansPricing.map(plan => /*#__PURE__*/_jsx(Cell, {
                title: translate('plan_option.title', {
                  count: plan.maxActiveCount
                }, {
                  count: plan.maxActiveCount
                }),
                body: translate('duration_day_count', {
                  count: plan.effectiveDays
                }, {
                  count: plan.effectiveDays
                }),
                suffix: formatCurrencyAmount(plan.totalPrice, locale)
              }, plan.id))
            })
          })
        })
      })]
    });
  }

  return /*#__PURE__*/_jsx(Modal, {
    show: isShown,
    hasScrollableContent: true,
    testId: "multiple-collections-plans-modal",
    children: /*#__PURE__*/_jsxs("div", {
      className: "u-fill-width",
      children: [renderNavigation(), /*#__PURE__*/_jsx(Divider, {}), /*#__PURE__*/_jsx(ScrollableArea, {
        children: renderContent()
      }), /*#__PURE__*/_jsxs(Cell, {
        children: [/*#__PURE__*/_jsx("div", {
          className: "u-flexbox u-justify-content-center u-ui-margin-bottom-regular",
          children: /*#__PURE__*/_jsx(Text, {
            text: translate('note'),
            type: Text.Type.Caption
          })
        }), /*#__PURE__*/_jsx(Button, {
          text: translate('actions.create'),
          styling: Button.Styling.Filled,
          onClick: handleCreateCollectionsClick,
          testId: "multiple-collections-plans-create-button"
        })]
      })]
    })
  });
};

export default MultipleCollectionsPlansModal;